import { TypeLocal } from 'interfaces/Dvf'
import { ReactComponent as PictoAppartement } from 'assets/default/svg/picto_appartement.svg'
import { ReactComponent as PictoDependance } from 'assets/default/svg/picto_dependance.svg'
import { ReactComponent as PictoLocalCommercial } from 'assets/default/svg/picto_local_commercial.svg'
import { ReactComponent as PictoMaison } from 'assets/default/svg/picto_maison_etudier_marche.svg'

const getFormattedLocalType = (
  localTypeToFormat: TypeLocal
): React.ReactNode => {
  if (localTypeToFormat === TypeLocal.Maison) {
    return (
      <>
        Maison <PictoMaison />
      </>
    )
  }

  if (localTypeToFormat === TypeLocal.Appartement) {
    return (
      <>
        Appartement <PictoAppartement />
      </>
    )
  }

  if (localTypeToFormat === TypeLocal.Dependance) {
    return (
      <>
        Dépendance <PictoDependance />
      </>
    )
  }

  if (localTypeToFormat === TypeLocal.LocalIndustrieCommerceAssimile) {
    return (
      <>
        Local industriel commercial ou assimilé <PictoLocalCommercial />
      </>
    )
  }

  return null
}

export default getFormattedLocalType
